module.exports = __webpack_public_path__ + "img/layout-sidebar-inset-reverse.9935c61d.svg";